import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialRejectionPopup } from './MaterialRejectionTable';
import { decryptAES, encryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';

export default class MaterialRejection extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            route: null,
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isSelectItemPopUp: false,
            isShown: false,
            partyAccountList: [],
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialObject: {
                idMaterialRejection: 0,
                idMaterialIssueJobWork: 0,
                idMaterialTesting: 0,
                updateStatus: 0,
                rejectionNo: '',
                rejectionDate: '',
                idRejection: 1,
                rejList: [
                    { value: 1, label: 'MATERIAL TESTING' },
                    { value: 2, label: 'REWORK PRODUCT' },
                ],
                idEmployee: 0,
                EmployeeList: [],
                idVendor: 0,
                workOrderList: [],
                testingDate: '',
                idRejType: 1,
                rejTypeList: [
                    { value: 1, label: 'INTRASTATE' },
                    { value: 2, label: 'INTERSTATE' },
                ],

                totalQty: '',
                totalAmt: '',
                taxAmt: '',
                taxableAmt: '',
                totalwithTax: '',
                finalAmt: '',
                adjustableAmt: '',
                prefix: '',
            },
            itemObject: {
                drawingNo: '',
                idType: 1,
                TypeList: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                ],
                idItem: 0,
                ItemList: [],
                quantity: '',
                rate: '',
                amount: '',
                idTaxGroup: 0,
                taxList: [],
                sgst: '',
                cgst: '',
                igst: '',
                sgstAmt: '',
                cgstAmt: '',
                igstAmt: '',
                netTotal: '',
                remarks: '',
                rejQuantity: 0,
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPurchase: {
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }


    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Rejection",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialRejection"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Rejection",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Material Rejection");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    usp_Master_PartyAccountSelect = () => {
        this.transactionStockServices.usp_Master_PartyAccountSelectSupplier(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    this.getTaxStructure()
                    this.setState({ partyAccountList: dynamicData }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getTaxStructure()
                }
            }
        });
    }

    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    value: x.idTaxStructure,
                    label: x.taxStructureName,
                }));
                let itemObject = this.state.itemObject;
                itemObject.taxList = res;
                this.setState({
                    itemObject: itemObject
                }, () => {
                    // this.usp_Master_ItemSelectForAuto()
                })
            } else {
                // this.usp_Master_ItemSelectForAuto()
            }
        });
    }

    // usp_Master_ItemSelectForAuto = () => {
    //     this.transactionStockServices.usp_Master_ItemSelectForAuto(this.state.idCompany).then((response) => {
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let res = response.responseItem.responseContent;
    //             res = res.map((x) => ({
    //                 id: x.idTaxStructure,
    //                 name: x.taxStructureName,
    //             }));
    //             let itemObject = this.state.itemObject;
    //             itemObject.ItemList = res;
    //             this.setState({
    //                 itemObject: itemObject
    //             }, () => {
    //             })
    //         } else {
    //         }
    //     });
    // }

    getColumnWidth = (key) => {
        const colwidth = {
            "srNo": window.innerWidth * 0.04,
            "rejectionNo": window.innerWidth * 0.05,
            "rejectionDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.17,
            "rejectionFrom": window.innerWidth * 0.11,
            "totalQty": window.innerWidth * 0.06,
            "totalAmt": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
            "testingNo": window.innerWidth * 0.06,
            "closeStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.15,
            "itemName": window.innerWidth * 0.15,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "amount": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    handleCellClick = (event) => {
        let data = this.state.materialObject;
        data.idMaterialRejection = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ materialObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Material Rejection");
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.transactionStockServices.usp_Transaction_MaterialRejectionCount(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let count = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (count.toString().length === 1) {
                    formatted = '00' + count;
                } else if (count.toString().length === 2) {
                    formatted = '0' + count;
                } else {
                    formatted = count.toString();
                }
                let materialObject = this.state.materialObject
                materialObject.rejectionNo = formatted
                materialObject.rejectionDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ materialObject: materialObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        if (event.data.rejectionFrom !== 'REWORK PRODUCT') {
            this.getMaterialRejectionSelectbyId(event.data.idMaterialRejection);
            let validState = this.state.validState;
            validState.isValid = true;
            validState.error = {};
            this.setState({
                validState: validState
            });
        } else {
            const encryptId = encryptAES(event.data.idRework);
            this.setState({ route: `/rework-product?idRework=${encryptId}` });
        }
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRulesForPurchase,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForPurchase = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details }, () => {
            this.finalCalculation()
        });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details }, () => {
            if (name === "quantity" || name === "rate") {
                this.calculatePricing()
            }
        });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.materialObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'materialObject') {
            details[name] = value;
            this.setState({ materialObject: details }, () => {
                if (name === "idVendor") {
                    this.getMaster_ItemSelectbyItemType(this.state.itemObject.TypeList.find(x => x.value === this.state.itemObject.idType).label);
                }
                if (name === 'idRejType') {
                    this.getTaxStructureSelectbyID();
                }
            });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details1 }, () => {
                if (name === "idType") {
                    this.getMaster_ItemSelectbyItemType(event.label);
                }
                if (name === "idTaxGroup") {
                    this.getTaxStructureSelectbyID();
                }
            });
        }
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let details = this.state.materialObject;
        details.idMaterialRejection = 0;
        details.idMaterialIssueJobWork = 0;
        details.idMaterialTesting = 0;
        details.rejectionDate = moment(new Date()).format('YYYY-MM-DD');
        details.idRejection = 1;
        details.idEmployee = 0;
        details.idVendor = 0;
        details.testingDate = '';
        details.totalQty = '';
        details.totalAmt = '';
        details.taxAmt = '';
        details.taxableAmt = '';
        details.totalwithTax = '';
        details.finalAmt = '';
        details.adjustableAmt = '';
        details.prefix = '';
        this.setState({
            validState: validState,
            materialObject: details,
            itemRowData: [],
        }, () => {
            this.resetitemObject();
        });
    }

    handleOnClick = (event, name) => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.usp_Master_ItemSelectbyID_JobWork(event.data.idItem);
        });
    };

    usp_Master_ItemSelectbyID_JobWork = (id) => {
        let request = {
            idItem: id,
            idVendor: this.state.materialObject.idVendor,
        }
        if (id !== 0 && this.state.materialObject.idVendor !== 0) {
            this.transactionStockServices.usp_Master_ItemSelectbyID_JobWork(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent[0];
                    let details = this.state.itemObject;
                    details.idTaxGroup = data.idTaxGroup ? data.idTaxGroup : 0;
                    details.rate = data.finalItemRate ? data.finalItemRate : 0;
                    details.drawingNo = data.drawingNo ? data.drawingNo : "";
                    this.setState({ itemObject: details }, () => {
                        this.getTaxStructureSelectbyID();
                    })
                }
            });
        }
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [
            this.state.idCompany,
            label,
            this.state.materialObject.idVendor
        ];
        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({
                    itemList: data,
                });
            }
        });
    }

    getTaxStructureSelectbyID = () => {
        if (this.state.itemObject.idTaxGroup > 0) {
            this.accountTransactionServices.getTaxStructureSelectbyID(this.state.itemObject.idTaxGroup).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.itemObject;
                    data.sgst = res.sgst;
                    data.cgst = res.cgst;
                    data.igst = res.igst;
                    this.setState({ itemObject: data }, () => {
                        this.calculatePricing();
                    });
                }
            });
        }
    }

    calculatePricing = () => {
        if (this.state.itemObject.rate) {
            let itemObject = this.state.itemObject;
            let materialObject = this.state.materialObject;
            itemObject.total = 0;
            itemObject.sgstAmt = 0;
            itemObject.cgstAmt = 0;
            itemObject.igstAmt = 0;
            itemObject.netTotal = 0;
            itemObject.amount = 0
            itemObject.amount = (Number(itemObject.quantity) * Number(itemObject.rate)).toFixed(2);
            itemObject.total = Number(itemObject.amount);
            itemObject.sgstAmt = materialObject.idRejType === 1 ? Number(((itemObject.total * itemObject.sgst) / 100).toFixed(2)) : 0;
            itemObject.cgstAmt = materialObject.idRejType === 1 ? Number(((itemObject.total * itemObject.cgst) / 100).toFixed(2)) : 0;
            itemObject.igstAmt = Number(itemObject.igst) > 0 ? materialObject.idRejType === 1 ? 0 : Number(((itemObject.total * itemObject.igst) / 100).toFixed(2)) : 0;
            itemObject.netTotal = (
                Number(itemObject.total) +
                Number(itemObject.sgstAmt) +
                Number(itemObject.cgstAmt) +
                Number(itemObject.igstAmt)
            ).toFixed(2);
            this.setState({ itemObject: itemObject });
        }
    }

    insert = (flag) => {
        let isValid = this.isValidAllFieldsForItem();
        if (!isValid) {
            this.SwalServices.Error("Please fill all required fields.");
            return;
        }
        if (flag === 'Insert') {
            let details = this.state.itemObject;
            let array = this.state.itemRowData;

            const isItemExists = array.some(x => x.idItem === details.idItem);

            if (isItemExists) {
                this.SwalServices.Error("This item is already added.");
                return;
            }
            let itemList = [...this.state.itemRowData];
            let obj = {
                drawingNo: details.drawingNo,
                idType: details.idType,
                materialType: details.TypeList.find(x => x.value === details.idType)?.label,
                idItem: details.idItem,
                itemName: details.itemIdLabel,
                quantity: Number(details.quantity),
                rate: details.rate,
                amount: Number(details.amount),
                idTaxGroup: details.idTaxGroup,
                sgst: details.sgst,
                sgstAmt: Number(details.sgstAmt),
                cgst: details.cgst,
                cgstAmt: Number(details.cgstAmt),
                igst: details.igstAmt > 0 ? details.igst : 0,
                igstAmt: Number(details.igstAmt),
                netTotal: Number(details.netTotal),
                remarks: details.remarks,
                rejQuantity: 0,
            }
            itemList.push(obj);
            itemList.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ itemRowData: itemList }, () => {
                this.resetitemObject();
                this.finalCalculation();
            });
        }
        else if (flag === 'Update') {
            let details2 = this.state.itemObject;
            let itemList2 = [...this.state.itemRowData];
            let obj2 = {
                drawingNo: details2.drawingNo,
                idType: details2.idType,
                materialType: details2.TypeList.find(x => x.value === details2.idType)?.label,
                idItem: details2.idItem,
                itemIdLabel: details2.itemIdLabel,
                itemName: details2.itemIdLabel,
                quantity: Number(details2.quantity),
                rate: Number(details2.rate),
                amount: Number(details2.amount),
                idTaxGroup: details2.idTaxGroup,
                sgst: details2.sgst,
                sgstAmt: Number(details2.sgstAmt),
                cgst: details2.cgst,
                cgstAmt: Number(details2.cgstAmt),
                igst: details2.igstAmt > 0 ? details2.igst : 0,
                igstAmt: Number(details2.igstAmt),
                netTotal: Number(details2.netTotal),
                remarks: details2.remarks,
                rejQuantity: details2.rejQuantity,
            };
            itemList2[details2.keyId - 1] = obj2;
            itemList2.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ itemRowData: itemList2 }, () => {
                this.resetitemObject();
                this.finalCalculation();
            });
        }
    }

    resetitemObject = () => {
        let details = this.state.itemObject;
        details.drawingNo = '';
        details.idType = 1;
        details.idItem = 0;
        details.itemIdLabel = "";
        details.quantity = 0;
        details.rate = 0;
        details.amount = 0;
        details.idTaxGroup = "";
        details.sgst = "";
        details.sgstAmt = "";
        details.cgst = "";
        details.cgstAmt = "";
        details.igst = "";
        details.igstAmt = "";
        details.netTotal = "";
        details.remarks = "";
        details.keyId = "";
        this.setState({ itemObject: details })
    }

    finalCalculation = () => {
        let data = this.state.itemRowData;
        let finalAmountCal = this.state.materialObject;

        finalAmountCal.totalQty = 0;
        finalAmountCal.totalAmt = 0;
        finalAmountCal.taxAmt = 0;
        finalAmountCal.totalwithTax = 0;
        finalAmountCal.taxableAmt = 0;
        finalAmountCal.finalAmt = 0;

        data.map((x) => {
            finalAmountCal.totalQty += Number(x.quantity);
            finalAmountCal.totalAmt += Number(x.amount);
            finalAmountCal.taxAmt += Number(x.sgstAmt) + Number(x.cgstAmt) + Number(x.igstAmt);
            finalAmountCal.taxableAmt += Number(x.total)
            finalAmountCal.finalAmt += Number(x.netTotal);
        });

        finalAmountCal.totalwithTax =
            Number(finalAmountCal.totalAmt) + Number(finalAmountCal.taxAmt);

        finalAmountCal.finalAmt = Number(finalAmountCal.totalwithTax).toFixed(2);

        finalAmountCal.taxableAmt = Number(finalAmountCal.taxableAmt).toFixed(2)
        finalAmountCal.totalAmt = Number(finalAmountCal.totalAmt).toFixed(2);
        finalAmountCal.taxAmt = Number(finalAmountCal.taxAmt).toFixed(2);
        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsAmt).toFixed(2);
        finalAmountCal.totalwithTax = Number(finalAmountCal.totalwithTax).toFixed(2);
        finalAmountCal.finalAmt = Math.round(Number(finalAmountCal.finalAmt) + (Number(finalAmountCal.adjustableAmt) || 0));

        this.setState({ materialObject: finalAmountCal });
    }

    onItemRowDataClicked = (event) => {
        let data = [...this.state.itemRowData];
        let getItemData = data[event.data.keyId - 1];
        let details = this.state.itemObject;

        details.drawingNo = getItemData.drawingNo;
        details.idType = getItemData.idType;
        details.itemIdLabel = getItemData.itemName;
        details.idItem = getItemData.idItem;
        details.quantity = getItemData.quantity;
        details.rate = getItemData.rate;
        details.amount = Number(getItemData.amount).toFixed(2);
        details.idTaxGroup = getItemData.idTaxGroup;
        details.sgst = getItemData.sgst;
        details.sgstAmt = getItemData.sgstAmt;
        details.cgst = getItemData.cgst;
        details.cgstAmt = getItemData.cgstAmt;
        details.igst = getItemData.igst;
        details.igstAmt = getItemData.igstAmt;
        details.netTotal = Number(getItemData.netTotal).toFixed(2);
        details.remarks = getItemData.remarks;
        details.keyId = getItemData.keyId;
        this.setState({ itemObject: details }, () => {
            this.getMaster_ItemSelectbyItemType(this.state.itemObject.TypeList.find(x => x.value === this.state.itemObject.idType).label)
        });
    };

    submit = () => {
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFieldsForRegister = this.isValidAllFieldsForRegister();
        if (isValidAllFieldsForRegister) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Alert("Please add product items details");
            } else {
                let data = this.state.materialObject
                let itemObject = this.state.itemObject;
                let request = {
                    idMaterialRejection: data.idMaterialRejection,
                    idMaterialIssueJobWork: data.idMaterialIssueJobWork,
                    updateStatus: data.updateStatus,
                    rejectionNo: data.rejectionNo,
                    rejectionDate: data.rejectionDate && data.rejectionDate !== 'Invalid date' ? data.rejectionDate : null,
                    idVendor: data.idVendor,
                    rejectionFrom: data.rejList.find(x => x.value === data.idRejection)?.label,
                    idMaterialTesting: data.idMaterialTesting,
                    testingDate: data.testingDate && data.testingDate !== 'Invalid date' ? data.testingDate : null,
                    idEmployee: data.idEmployee,
                    rejectionType: data.rejTypeList.find(x => x.value === data.idRejType)?.label,
                    totalQty: data.totalQty,
                    totalAmt: data.totalAmt,
                    taxAmt: data.taxAmt,
                    totalwithTax: data.totalwithTax,
                    taxableAmt: data.taxableAmt,
                    finalAmt: data.finalAmt,
                    remarks: data.remarks ? data.remarks : "",
                    idCompany: this.state.idCompany,
                    e_Date: data.e_Date ? moment(data.e_Date).format('YYYY-MM-DD') : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? moment(new Date().toISOString()).format('YYYY-MM-DD') : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: 0,
                    prefix: data.prefix,
                    adjustableAmt: data.adjustableAmt
                };
                request.itemList = [];
                let itemList = this.state.itemRowData;
                itemList.map((details) => {
                    let obj = {
                        idMaterialRejection: details.idMaterialRejection,
                        drawingNo: details.drawingNo,
                        itemType: itemObject.TypeList.find(x => x.value === details.idType)?.label,
                        idItem: details.idItem,
                        quantity: details.quantity,
                        rate: details.rate,
                        amount: details.amount,
                        sgst: details.sgst,
                        sgstAmt: details.sgstAmt,
                        cgst: details.cgst,
                        cgstAmt: details.cgstAmt,
                        igst: details.igst,
                        igstAmt: details.igstAmt,
                        netTotal: details.netTotal,
                        idTaxGroup: details.idTaxGroup ? details.idTaxGroup : 0,
                        itemRemarks: details.remarks,
                        rejectionFrom: data.rejList.find(x => x.value === data.idRejection)?.label,
                        idMaterialTesting: 0,
                        idMaterialIssueJobWork: 0,
                        idDisAssemble: 0,
                        idDisAssembleItem: 0,
                    }
                    request.itemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitMaterialRejection(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.materialObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                    //receiptDetails: reset
                                }, () => {
                                    this.resetDetailsFields();
                                    this.procSelectAllRecordsSP();
                                });
                            }
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    deleteItem = (keyId) => {
        let data = this.state.itemObject;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }

        this.setState({ itemObject: { ...data }, itemRowData: filterData }, () => {
            this.resetitemObject();
            this.finalCalculation();
        });
    }

    getMaterialRejectionSelectbyId = (idMaterialRejection) => {
        if (idMaterialRejection > 0) {
            this.transactionStockServices.getMaterialRejectionSelectbyId(idMaterialRejection).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let materialObject = this.state.materialObject;
                    materialObject.idMaterialRejection = res.idMaterialRejection;
                    materialObject.updateStatus = 1;
                    materialObject.rejectionNo = res.rejectionNo
                    materialObject.rejectionDate = res.rejectionDate ? moment(res.rejectionDate).format('YYYY-MM-DD') : null;
                    materialObject.idRejection = res.rejectionFrom ? materialObject.rejList.find(x => x.label === res.rejectionFrom)?.value : 1;
                    materialObject.idVendor = res.idVendor;
                    materialObject.testingDate = res.testingDate ? moment(res.testingDate).format('YYYY-MM-DD') : '';
                    materialObject.idRejType = res.rejectionType ? materialObject.rejTypeList.find(x => x.label === res.rejectionType)?.value : 2;

                    materialObject.idEmployee = res.idEmployee ? res.idEmployee : 0;
                    materialObject.e_Date = res.e_Date;
                    materialObject.totalQty = res.totalQty;
                    materialObject.totalAmt = res.totalAmt;
                    materialObject.taxAmt = res.taxAmt;
                    materialObject.totalwithTax = res.totalwithTax;
                    materialObject.finalAmt = res.finalAmt;
                    materialObject.adjustableAmt = res.adjustableAmt;

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            idMaterialRejectionItems: details.idMaterialRejectionItems,
                            drawingNo: details.drawingNo,
                            idType: this.state.itemObject.TypeList?.find(x => x.label === details.itemType)?.value,
                            materialType: details.itemType ? details.itemType : "",
                            rejQuantity: details.rejQuantity ? details.rejQuantity : 0,
                            idItem: details.idItem ? details.idItem : 0,
                            itemIdLabel: details.itemName ? details.itemName : "",
                            itemName: details.itemName ? details.itemName : "",
                            quantity: details.quantity ? details.quantity : 0,
                            rate: details.rate ? details.rate : 0,
                            amount: details.amount ? details.amount : 0,
                            idTaxGroup: details.idTaxGroup ? details.idTaxGroup : 0,
                            sgst: details.sgst,
                            cgst: details.cgst,
                            igst: details.igst,
                            sgstAmt: details.sgstAmt,
                            cgstAmt: details.cgstAmt,
                            igstAmt: details.igstAmt,
                            netTotal: details.netTotal,
                            remarks: details.itemRemarks,
                            keyId: keyId + 1,
                        }
                        itemList.push(obj);
                    })
                    this.setState({ materialObject: materialObject, itemRowData: itemList, isModalOpen: true, globalUserID: res.modifiedBy }, () => {
                        this.finalCalculation()
                    });
                }
            });
        }
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialRejectionPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            itemObject={this.state.itemObject}
                            handleChangeForPurchase={this.handleChangeForPurchase.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            partyAccountList={this.state.partyAccountList}
                            handleOnClick={this.handleOnClick.bind(this)}
                            insert={this.insert.bind(this)}
                            handleCellClickItemList={this.handleDropdownCellClick.bind(this)}
                            onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                            clearItemObject={this.resetitemObject.bind(this)}
                            delete={this.deleteItem.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material rejection</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </div>
        )
    }
}
